export default __webpack_public_path__ + "static/cruiselines-royal-activities-6-c86a39d778bbdf73faea7b6c07c9f02e.jpg";